import React, { FunctionComponent } from 'react'
import { StructFilterLabelType } from '../lib/structures'

interface Props {
  filterPersonType: StructFilterLabelType[] | undefined
  onChange: (filterPersonType: StructFilterLabelType[]) => void
}

const PeopleCheckableFilter: FunctionComponent<Props> = props => {
  const { filterPersonType, onChange } = props
  return (
    <th colSpan={1} rowSpan={2} style={{ borderLeft: '1px solid #ccc' }}>
      <span>People:</span><br />
      {[
        { value: 'public_rep', label: 'Public Rep' },
        { value: 'candidate', label: 'Candidate' },
        { value: 'staff', label: 'Staff' },
        { value: 'activist', label: 'Activist' }
      ].map(({ value, label }) => (
        <div key={value}>
          <label key={value} style={{ marginBottom: 0 }}>
            <input
              style={{ marginRight: '15px' }}
              type='checkbox'
              value={value}
              checked={
                      filterPersonType?.includes(
                        value as StructFilterLabelType
                      ) ?? false
                    }
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const newValues = (filterPersonType != null)
                  ? [...filterPersonType]
                  : []
                if (event.target.checked) {
                  newValues.push(value as StructFilterLabelType)
                } else {
                  newValues.splice(
                    newValues.indexOf(value as StructFilterLabelType),
                    1
                  )
                }
                onChange(newValues)
              }}
            />
            {label}
          </label>
          <br />
        </div>
      ))}
    </th>
  )
}

export default PeopleCheckableFilter
